<template>
  <div class="component-box">
    <h5 class="component-name">时间：</h5>
    <el-radio-group v-model="timeAlias" size="small" @change="setTime">
      <el-radio-button label="yesterday">昨天</el-radio-button>
      <el-radio-button label="week">近7天</el-radio-button>
      <el-radio-button label="month">近1个月</el-radio-button>
      <el-radio-button label="year">近1年</el-radio-button>
    </el-radio-group>
    <div class="picker-box">
      <el-date-picker
        type="date"
        placeholder="选择开始日期"
        v-model="queryParams.startTime"
        @change="changeDate"
        :picker-options="startDateOptions"
        value-format="yyyy-MM-dd"
        style="width: 185px"
      ></el-date-picker>
      <p>-</p>
      <el-date-picker
        type="date"
        placeholder="选择结束日期"
        v-model="queryParams.endTime"
        @change="changeDate"
        :picker-options="endDateOptions"
        value-format="yyyy-MM-dd"
        style="width: 185px"
      ></el-date-picker>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopCenterAdminWebDatePicker",
  props: {
    setDate: {
      type: Object,
      default: () => {},
    },
    hasCurrent: {
      type: Number,
      default: 0, // 0-包含今天 1-不包含今天
    },
  },
  data() {
    return {
      startDateOptions: {
        disabledDate: (time) => {
          return (
            // 不能选择今天以后的日期
            time.getTime() > Date.now() - this.hasCurrent * 8.64e7 ||
            // 如果设置了endTime 则startTime不能在endTime之后
            (this.queryParams.endTime
              ? time.getTime() >= new Date(this.queryParams.endTime).getTime()
              : false) ||
            // 时间段不能跨年 如果设置了endTime 则只能在endTime的相同年份内选择
            (this.queryParams.endTime
              ? time.getFullYear() <
                new Date(this.queryParams.endTime).getFullYear()
              : false)
          );
        },
      },
      endDateOptions: {
        disabledDate: (time) => {
          return (
            // 不能选择今天以后的日期
            time.getTime() >= Date.now() - this.hasCurrent * 8.64e7 ||
            // 如果设置了startTime 则endTime不能在startTime之前
            (this.queryParams.startTime
              ? time.getTime() <=
                new Date(this.queryParams.startTime).getTime() - 8.64e7
              : false) ||
            // 时间段不能跨年 如果设置了startTime 则只能在startTime的相同年份内选择
            (this.queryParams.startTime
              ? time.getFullYear() >
                new Date(this.queryParams.startTime).getFullYear()
              : false)
          );
        },
      },
      // 时间段别名
      timeAlias: "year", // yesterday-昨天, week-近七天, month-近一个月, year-近一年 none-具体时间段
      //查询参数
      queryParams: {
        //查询时间
        startTime: "",
        endTime: "",
        shopId: this.$store.state.user.userInfo.shopId,
      },
    };
  },
  watch: {
    setDate: {
      handler() {
        // 如果父组件传入了时间段 则使用父组件传入的时间段
        if (this.setDate && this.setDate.startTime && this.setDate.endTime) {
          this.queryParams = Object.assign(this.queryParams, this.setDate);
          // 如果startTime为之前几年的时间 并且开始时间和结束时间跨年了
          // 由于不允许跨年 所以设置startTime为本年的1月1号
          if (
            new Date(this.setDate.startTime).getFullYear() !==
              new Date(this.setDate.endTime).getFullYear() &&
            new Date(this.setDate.startTime).getFullYear() !==
              new Date().getFullYear()
          ) {
            this.queryParams.startTime = `${new Date().getFullYear()}-01-01`;
          }
          this.timeAlias = this.setDate.timeAlias || "none";
        } else {
          this.setTime();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},

  methods: {
    // 向父组件返回数据
    returnData() {
      // 只有时间段完整 才会触发事件
      if (this.queryParams.startTime && this.queryParams.endTime) {
        this.$emit(
          "changeDate",
          Object.assign(this.queryParams, { timeAlias: this.timeAlias })
        );
      }
    },
    // 切换时间段
    changeDate() {
      this.timeAlias = "none";
      this.returnData();
    },
    /*设置开始时间和结束时间*/
    setTime() {
      let queryParams = JSON.parse(JSON.stringify(this.queryParams));
      let timeType = this.timeAlias;
      var nowData = new Date(
        new Date().setDate(new Date().getDate() - this.hasCurrent)
      );
      var startTime = new Date();
      if (timeType == "week") {
        startTime = new Date(new Date().setDate(new Date().getDate() - 7));
      } else if (timeType == "month") {
        startTime = new Date(new Date().setMonth(new Date().getMonth() - 1));
      } else if (timeType == "yesterday") {
        startTime = new Date(new Date().setDate(new Date().getDate() - 1));
      } else if (timeType == "year") {
        startTime = new Date(`${new Date().getFullYear()}-01-01`);
      }
      // 如果startTime为去年的时间 不允许跨年 则startTime为本年的1月1号
      if (startTime.getFullYear() !== new Date().getFullYear()) {
        startTime = new Date(`${new Date().getFullYear()}-01-01`);
      }
      let month = startTime.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let day = startTime.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      queryParams.startTime = startTime.getFullYear() + "-" + month + "-" + day;
      // }
      // if (queryParams.endTime != null) {
      month = nowData.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      day = nowData.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      queryParams.endTime = nowData.getFullYear() + "-" + month + "-" + day;
      // }
      this.queryParams = queryParams;
      this.returnData();
    },
  },
};
</script>

<style lang="scss" scoped>
.component-box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 10px;
  .component-name {
    margin-right: 12px;
    color: #616366;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 100% */
  }
  .picker-box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 32px;
    margin-left: 10px;
    & > p {
      margin: 0 10px;
    }
    ::v-deep .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
    ::v-deep .el-input__icon {
      line-height: 32px;
    }
  }
}
</style>
